import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { IEntityContentField } from '../../lib/interfaces/Common';
import { IProduct } from '../../lib/interfaces/Product';
import { FIELD_TYPES } from '../Form/form.utils';
import { setLoginModalOpen } from '../../redux/reducers/ui/modalsReducer';
import ContentRenderer from '../Smart/Content/ContentRenderer';
import Mock from '../../static/assets/hero_1.jpg';
import paths from '../../lib/consts/paths';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import { currencyFormatter } from '../../lib/helpers/currency.helper';
import './ProductCard.scss';
import CtaButton from '../Simple/CtaButtons/CtaButton';

type ProductsCardType = {
	product: IProduct;
};

const ProductsCard: FC<ProductsCardType> = ({ product }) => {
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { imageUrl, content, price, slug } = product;
	const { data: currentUser } = useUserMeQuery();
	const currentLanguage: string = i18n.language;
	const contentFields: IEntityContentField[] = content[currentLanguage];
	const handleOrder = () => {
		if (currentUser) {
			navigate(`${paths.orders}/${slug}`);
		} else {
			dispatch(setLoginModalOpen(true));
		}
	};
	const handleProductDetails = () => {
		navigate(`${paths.products}/${slug}`);
	};
	const blockedFields = [
		`content_full_${currentLanguage}`,
		`content_order_page_${currentLanguage}`,
	];

	return (
		<Paper
			className="ProductCard"
			elevation={0}
			variant="outlined"
			sx={{ borderRadius: '10px', overflow: 'hidden' }}
		>
			<div className="ProductCard__image-container">
				<div className="ProductCard__image-container__plan">New</div>
				<img
					src={imageUrl || Mock}
					alt={product.name}
					className="ProductCard__image-container__image"
				/>
			</div>
			<div className="ProductCard__content">
				{contentFields.map((field) => {
					if (field.type === FIELD_TYPES.TEXT) {
						return (
							<>
								<Typography
									variant="h5"
									sx={{ fontWeight: 600 }}
									gutterBottom
									component="div"
									key={field.name}
								>
									{field.content}{' '}
								</Typography>
								<Typography
									sx={{ fontWeight: 600 }}
									variant="h4"
									gutterBottom
									component="div"
								>
									{currencyFormatter(price)}
								</Typography>
							</>
						);
					}
					if (
						field.type === FIELD_TYPES.RICH_EDITOR &&
						!blockedFields.includes(field.name)
					) {
						return <ContentRenderer html={field.content} key={field.name} />;
					}
					return null;
				})}
				<div className="ProductCard__to-course">
					<Button variant="text" disableElevation onClick={handleProductDetails}>
						{t('moreDetails')}
					</Button>
					<CtaButton variant="contained" disableElevation onClick={handleOrder}>
						{t('order')}
					</CtaButton>
				</div>
			</div>
		</Paper>
	);
};

export default ProductsCard;
